import Link from "../Link";

const Docker = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/10" title={"OpenBootcamp Docker"} />
            <Link url="https://www.youtube.com/watch?v=SMqdC6g6Y2o" title={"Docker para Devs - Fazt"} />
            <Link url="https://www.youtube.com/watch?v=4Dko5W96WHg" title={"Docker Desde 0 - Hola Mundo"} />
        </div>
    );
}

export default Docker;